// CompanyRetirementPDF.js
import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import moment from "moment";
import logo from "../../logo-succession-now.png";
import Shape from "../../shape.png";
//import { display } from "html2canvas/dist/types/css/property-descriptors/display";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    flexWrap: "wrap",
    padding: 10,
    fontSize: 10,
  },
  // card: {
  //   width: "48%",
  //   margin: "1%",
  //   border: "1 solid #ccc",
  //   borderRadius: 8,
  //   padding: 10,
  //   backgroundColor: "#ffffff",
  //   boxshadow: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
  // },
  cardHeader: {
    fontSize: 12,
    marginBottom: 6,
    fontWeight: "bold",
    color: "#111",
  },
  cardSub: {
    fontSize: 10,
    marginBottom: 8,
    color: "#444",
  },
  person: {
    paddingVertical: 4,
    borderBottom: "1 solid #eee",
  },
  name: {
    fontWeight: "bold",
    marginBottom: 2,
  },
  position: {
    fontSize: 9,
    color: "#666",
  },
  emptyMessage: {
    fontStyle: "italic",
    color: "#aaa",
    textAlign: "center",
    padding: 10,
  },
  gridContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: 10,
  },
  cardWrapper: {
    width: "100%",
    marginBottom: 20,
  },
  card: {
    borderRadius: 15,
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 3,
    overflow: "hidden",
    marginBottom: 5,
  },
  cardHeader: {
    backgroundColor: "#0f1c35",
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  cardTitle: {
    color: "#fff",
    fontSize: 14,
    fontWeight: "semibold",
  },
  cardSubtitle: {
    color: "#cfd8e3",
    fontSize: 10,
    marginTop: 2,
  },
  cardBody: {
    backgroundColor: "#fff",
    padding: 10,
  },
  personItem: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    borderColor: "#fddc9b",
    borderWidth: 1,
    borderRadius: 10,
    padding: 10,
    marginBottom: 10,
  },
  dot: {
    width: 10,
    height: 10,
    backgroundColor: "#f4c542",
    borderRadius: 5,
    marginRight: 10,
  },
  personName: {
    fontSize: 12,
    fontWeight: "bold",
  },
  personRole: {
    fontSize: 10,
    color: "#6c757d",
  },
  noRetirees: {
    textAlign: "center",
    padding: 10,
    color: "#888",
  },
});

const EligibilityOverviewChartPdf = ({
  chartImageUrl,
  user,
  companyLogo,
  title,
  pageTitle = "Company Retirement Data Report",
  pdfData,
  type,
  orderIngData,
  legendLabels
}) => {
  //console.log("chartImageUrl:", chartImageUrl);
  return (
    <Document>      
      <Page
        size="A4"
        orientation="portrait"
        style={{
          padding: 20,
          fontFamily: "RobotoRegular",
          lineHeight: 1.2,
          fontSize: 9,
          color: "#334155",
          backgroundColor: "#f1f5f9",
        }}
      >       
        {/* Background Elements */}
        <View
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
          }}
          fixed
        >
          <View
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              right: 0,
              width: "100%",
              height: 160,
              zIndex: -1,
              opacity: 0.1,
            }}
          >
            <Image style={{ objectFit: "cover" }} src={Shape} />
          </View>
          <View
            style={{
              position: "absolute",
              width: "100%",
              left: 0,
              bottom: -10,
              right: 0,
              height: 160,
              zIndex: -1,
              opacity: 0.075,
            }}
          >
            <Image style={{ objectFit: "contain" }} src={logo} />
          </View>
        </View>

        {/* Top Right Logo */}
        <View style={{ position: "absolute", right: 30, top: 30 }}>
          <Image
            style={{ width: 120, height: 24, objectFit: "contain" }}
            src={logo}
          />
        </View>

        {/* Header Section */}
        <View
          style={{
            paddingBottom: 30,
            width: "100%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Company Logo */}
          <View
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              fontSize: 16,
              alignItems: "center",
              position: "relative",
              width: "100%",
            }}
          >
            <Image
              style={{
                width: 360,
                height: 120,
                objectFit: "contain",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              src={companyLogo}
            />
          </View>

          {/* Company Name */}
          <View style={{ display: "flex", flexDirection: "row", marginTop: 15 }}>
            <Text
              style={{
                fontFamily: "RobotoBold",
                fontSize: 20,
                textTransform: "capitalize",
              }}
            >
              Company Name: {user?.company_name}
            </Text>
          </View>

          {/* Report Title */}
          {/* <View
            style={[{ display: "flex", flexDirection: "row", marginTop: 15 }]}
          >
            <Text
              style={{
                fontFamily: "RobotoBold",
                fontSize: 12,
                textTransform: "uppercase",
                color: "#14b8a6",
                letterSpacing: 3,
                textAlign: "center",
              }}
            >
              Visual{" "}
              {type && type === "retirement"
                ? "Retirement Window"
                : "Readiness Timeframe"}
            </Text>
          </View> */}

          {/* Date */}
          <View
            style={[
              {
                display: "flex",
                flexDirection: "row",
                marginTop: 5,
                textAlign: "center",
                justifyContent: "center",
              },
            ]}
          >              
            <View
              style={[{ display: "flex", flexDirection: "row", marginTop: 5 }]}
            >
              <Text style={[{ fontFamily: "RobotoMedium", fontSize: 10 }]}>
                Date:
              </Text>
              <Text
                style={{
                  fontFamily: "RobotoRegular",
                  fontSize: 10,
                  marginLeft: 2,
                }}
              >
                {moment(new Date()).format("MM/DD/YYYY")}
              </Text>
            </View>
          </View>
        </View>

        {/* Main Chart Section - Full Width Large Chart */}
        <View 
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 10,
          }}
        >          
          <View
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: 16,
              overflow: "hidden",
              backgroundColor: "#fff",
              padding: 20,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 500,
            }}
            wrap={false}
          >            
            <View
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginBottom: 20, // Reduced margin
              }}
            >
              {chartImageUrl && (
                <Image
                  src={chartImageUrl}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                    minHeight: 420, // Much larger image
                  }}
                />
              )}
            </View>

            {/* Compact Legend Text - Smaller to Give More Space to Image */}
            {legendLabels && legendLabels.length > 0 && (
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  columnGap: 16, // Reduced spacing
                  rowGap: 6, // Reduced spacing
                  width: "100%",
                }}
              >
                {legendLabels.map((item, index) => (
                  <View
                    key={index}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      columnGap: 6, // Reduced spacing
                      alignItems: "center",
                    }}
                  >
                    <View
                      style={{
                        width: 12, // Smaller legend squares
                        height: 12,
                        borderRadius: 3,
                        backgroundColor: item?.color,
                        border: "1px solid rgba(0,0,0,0.1)",
                      }}
                    />
                    <Text 
                      style={{ 
                        fontSize: 14, // Smaller text
                        fontFamily: "RobotoMedium",
                        color: "#334155",
                      }}
                    >
                      {item?.label}
                    </Text>
                  </View>
                ))}
              </View>
            )}
          </View>
        </View>
      </Page>

      <Page
        size="A4"
        orientation="portrait"
        style={{
          padding: 20,
          fontFamily: "Helvetica",
          fontSize: 9,
          color: "#334155",
          backgroundColor: "#f1f5f9",
        }}
      >
        {/* Main Container */}
        <View
          style={{
            width: "100%",
            flexDirection: "column",
            backgroundColor: "#ffffff",
            borderRadius: 12,
            overflow: "hidden",
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.1,
            shadowRadius: 6,
            elevation: 8,
          }}
        >
          {/* Header Section */}
          <View
            style={{
              width: "100%",
              paddingVertical: 15,
              paddingHorizontal: 20,
              backgroundColor:
                type === "retirement"
                  ? "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)"
                  : "linear-gradient(135deg, #059669 0%, #10b981 100%)",
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
            }}
          >
            <Text
              style={{
                fontFamily: "RobotoBold",
                fontSize: 14,
                color: "#ffffff",
                textAlign: "center",
                letterSpacing: 0.5,
              }}
            >
              Employee {type === "retirement" ? "Retirement" : "Readiness"}{" "}
              Summary Report
            </Text>
          </View>

          {/* Table Header */}
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              backgroundColor: "#1f2937",
              paddingVertical: 12,
              borderBottomWidth: 2,
              borderBottomColor: "#374151",
            }}
          >
            <View
              style={{
                width: "40%",
                paddingHorizontal: 12,
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  fontFamily: "RobotoBold",
                  fontSize: 10,
                  color: "#ffffff",
                  textAlign: "left",
                }}
              >
                Employee Name
              </Text>
            </View>

            <View
              style={{
                width: "35%",
                paddingHorizontal: 12,
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  fontFamily: "RobotoBold",
                  fontSize: 10,
                  color: "#ffffff",
                  textAlign: "center",
                }}
              >
                Position
              </Text>
            </View>

            <View
              style={{
                width: "25%",
                paddingHorizontal: 12,
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  fontFamily: "RobotoBold",
                  fontSize: 10,
                  color: "#ffffff",
                  textAlign: "center",
                }}
              >
                {type === "retirement"
                  ? "Retirement Window"
                  : "Readiness Timeline"}
              </Text>
            </View>
          </View>

          {/* Table Body */}
          <View style={{ width: "100%", flexDirection: "column" }}>
            {(() => {
              // Determine the field name and ordering data based on type
              const fieldName = type === "retirement" ? "window" : "readiness";
              const orderingData = orderIngData;

              // Create ordering map from the dynamic data
              const orderingMap = {};
              if (orderingData && Array.isArray(orderingData)) {
                orderingData.forEach((item) => {
                  orderingMap[item.name] = item.ordering || 999;
                });
              }

              // Group data by the appropriate field (window/readiness)
              const groupedByField = {};
              pdfData.forEach((item) => {
                const fieldValue = item[fieldName] || "Not Specified";
                if (!groupedByField[fieldValue]) {
                  groupedByField[fieldValue] = [];
                }
                groupedByField[fieldValue].push(item);
              });

              // Sort fields based on ordering
              const sortedFields = Object.keys(groupedByField).sort((a, b) => {
                const aOrder = orderingMap[a] || 999;
                const bOrder = orderingMap[b] || 999;
                return aOrder - bOrder;
              });

              // Get appropriate icon and colors based on type
              const getFieldStyles = (fieldValue) => {
                if (type === "retirement") {
                  // Retirement styling
                  const orderingItem = orderingData?.find(
                    (item) => item.name === fieldValue
                  );
                  const isEliminated = orderingItem?.isPass === false;

                  return {
                    icon: "🕐",
                    backgroundColor: isEliminated ? "#fef2f2" : "#e0f2fe",
                    borderColor: isEliminated ? "#dc2626" : "#0284c7",
                    textColor: isEliminated ? "#7f1d1d" : "#0c4a6e",
                    badgeColor: isEliminated ? "#fecaca" : "#dbeafe",
                    badgeBorder: isEliminated ? "#dc2626" : "#3b82f6",
                    badgeText: isEliminated ? "#991b1b" : "#1e40af",
                  };
                } else {
                  // Readiness styling
                  const orderingItem = orderingData?.find(
                    (item) => item.name === fieldValue
                  );
                  const isImmediate = fieldValue === "Immediate";

                  return {
                    icon: isImmediate ? "⚡" : "📈",
                    backgroundColor: isImmediate ? "#f0fdf4" : "#f0f9ff",
                    borderColor: isImmediate ? "#16a34a" : "#0369a1",
                    textColor: isImmediate ? "#14532d" : "#0c4a6e",
                    badgeColor: isImmediate ? "#dcfce7" : "#e0f2fe",
                    badgeBorder: isImmediate ? "#16a34a" : "#0369a1",
                    badgeText: isImmediate ? "#15803d" : "#0c4a6e",
                  };
                }
              };

              return sortedFields.map((fieldValue, fieldIndex) => {
                const fieldItems = groupedByField[fieldValue];
                const styles = getFieldStyles(fieldValue);

                // Further group by name within each field
                const groupedByName = {};
                fieldItems.forEach((item) => {
                  if (!groupedByName[item.name]) {
                    groupedByName[item.name] = [];
                  }
                  groupedByName[item.name].push(item);
                });

                return (
                  <View key={fieldValue} style={{ width: "100%" }}>
                    {/* Field Section Header */}
                    <View
                      style={{
                        width: "100%",
                        paddingVertical: 10,
                        paddingHorizontal: 15,
                        backgroundColor: styles.backgroundColor,
                        borderLeftWidth: 4,
                        borderLeftColor: styles.borderColor,
                        marginTop: fieldIndex > 0 ? 15 : 0,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: "RobotoBold",
                          fontSize: 11,
                          color: styles.textColor,
                          textAlign: "left",
                        }}
                      >
                        {styles.icon} {fieldValue} ({fieldItems.length} employee
                        {fieldItems.length > 1 ? "s" : ""})
                      </Text>
                    </View>

                    {/* Employees in this field group */}
                    {Object.keys(groupedByName).map((name, nameIndex) => {
                      const nameItems = groupedByName[name];

                      return nameItems.map((item, itemIndex) => {
                        const isFirstInGroup = itemIndex === 0;
                        const isDuplicate = nameItems.length > 1;

                        return (
                          <View key={`${name}-${itemIndex}`} wrap={false}>
                            {/* Add spacing between different names */}
                            {isFirstInGroup && nameIndex > 0 && (
                              <View
                                style={{
                                  width: "100%",
                                  height: 8,
                                  backgroundColor: "#f8fafc",
                                }}
                              />
                            )}

                            {/* Employee Row */}
                            <View
                              style={{
                                width: "100%",
                                flexDirection: "row",
                                backgroundColor:
                                  itemIndex % 2 === 0 ? "#ffffff" : "#f9fafb",
                                paddingVertical: 10,
                                paddingHorizontal: 12,
                                borderLeftWidth: isDuplicate ? 3 : 0,
                                borderLeftColor: isDuplicate
                                  ? "#f59e0b"
                                  : "transparent",
                                borderBottomWidth: 0.5,
                                borderBottomColor: "#e5e7eb",
                              }}
                            >
                              {/* Name Column */}
                              <View
                                style={{
                                  width: "40%",
                                  paddingRight: 8,
                                  justifyContent: "center",
                                }}
                              >
                                <Text
                                  style={{
                                    fontFamily: isFirstInGroup
                                      ? "RobotoBold"
                                      : "Helvetica",
                                    fontSize: isFirstInGroup ? 10 : 9,
                                    color: isFirstInGroup
                                      ? "#1f2937"
                                      : "#4b5563",
                                    textAlign: "left",
                                  }}
                                >
                                  {item.name}
                                </Text>
                                {isFirstInGroup && isDuplicate && (
                                  <Text
                                    style={{
                                      fontFamily: "Helvetica",
                                      fontSize: 7,
                                      color: "#f59e0b",
                                      textAlign: "left",
                                      marginTop: 2,
                                    }}
                                  >
                                    🔄 {nameItems.length} positions
                                  </Text>
                                )}
                              </View>

                              {/* Position Column */}
                              <View
                                style={{
                                  width: "35%",
                                  paddingHorizontal: 8,
                                  justifyContent: "center",
                                }}
                              >
                                <Text
                                  style={{
                                    fontFamily: "Helvetica",
                                    fontSize: 9,
                                    color: "#374151",
                                    textAlign: "center",
                                  }}
                                >
                                  {item.position}
                                </Text>
                              </View>

                              {/* Dynamic Field Column (Window/Readiness) */}
                              <View
                                style={{
                                  width: "25%",
                                  paddingLeft: 8,
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <View
                                  style={{
                                    backgroundColor: styles.badgeColor,
                                    paddingVertical: 4,
                                    paddingHorizontal: 8,
                                    borderRadius: 6,
                                    borderWidth: 1,
                                    borderColor: styles.badgeBorder,
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontFamily: "RobotoMedium",
                                      fontSize: 8,
                                      color: styles.badgeText,
                                      textAlign: "center",
                                    }}
                                  >
                                    {item[fieldName]}
                                  </Text>
                                </View>
                              </View>
                            </View>
                          </View>
                        );
                      });
                    })}
                  </View>
                );
              });
            })()}
          </View>

          {/* Footer */}
          <View
            style={{
              width: "100%",
              paddingVertical: 12,
              paddingHorizontal: 20,
              backgroundColor: "#f8fafc",
              borderTopWidth: 1,
              borderTopColor: "#e5e7eb",
              borderBottomLeftRadius: 12,
              borderBottomRightRadius: 12,
            }}
          >
            <Text
              style={{
                fontFamily: "Helvetica",
                fontSize: 8,
                color: "#6b7280",
                textAlign: "center",
              }}
            >
              Total Employees: {pdfData.length} |{" "}
              {type === "retirement" ? "Retirement" : "Readiness"} Report |
              Generated on {new Date().toLocaleDateString()}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default EligibilityOverviewChartPdf;